"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var module_1 = require("./module");
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.TopicTitle = function () {
    var modCtx = react_1.useContext(module_1.ModuleContext)[0];
    return react_1.default.createElement(creator_ui_1.Box, { mx: "10px" }, modCtx.currentTopic);
};
exports.TopicTitle.displayName = "TopicTitle";
